import { Badge, Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiCheckSquare } from "react-icons/fi";
import { EventDataDto } from "../../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../../common/input/TipTap/TipTap";
import { SectionCard } from "../../sourcing-events/portal/view-single/SectionCard";

const DASH = "–";

export const CriteriaSection = ({ eventData }: { eventData: EventDataDto }) => {
  const { t } = useTranslation();
  const award = eventData.awardCriteria;
  const awardLabel = award?.lowestPrice
    ? t("Lowest price")
    : award?.bestPriceQualityRatio
      ? t("Best price-quality ratio")
      : DASH;
  const selection = eventData.selectionCriteria ?? [];

  return (
    <SectionCard icon={FiCheckSquare} title={t("Criteria")}>
      <Stack spacing="5">
        <Stack spacing="1">
          <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
            {t("Award method")}
          </Text>
          <Text color="smText" fontSize="sm">
            {awardLabel}
          </Text>
        </Stack>
        <Stack spacing="1">
          <Text color="smMuted" fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="wide">
            {t("Selection criteria")}
          </Text>
          {selection.length > 0 ? (
            <Stack spacing="3" mt="1">
              {selection.map((c, i) => (
                <Box key={`${c.name}-${i}`} borderWidth="1px" borderColor="smBorder" rounded="md" px="4" py="3">
                  <Text fontWeight="semibold" color="smText" fontSize="sm">
                    {c.name}
                  </Text>
                  {!isTiptapContentEmpty(c.description) && (
                    <Box mt="1">
                      <TipTap content={c.description} editable={false} hasBorder={false} padding="0" maxHeight="" />
                    </Box>
                  )}
                  <Box mt="2">
                    <Badge colorScheme="gray">{t(c.type)}</Badge>{" "}
                    {c.requiresEvidence && <Badge colorScheme="purple">{t("Evidence required")}</Badge>}
                  </Box>
                </Box>
              ))}
            </Stack>
          ) : (
            <Text color="smText" fontSize="sm">
              {DASH}
            </Text>
          )}
        </Stack>
      </Stack>
    </SectionCard>
  );
};
